/* pd-r16 — Apple design pass, round 2 (17 Oct 2026).
   3. Quantity +/- on the product page: hold to keep counting.
   7. Tap the bottom-bar tab for the page you're on to glide back to the top.
   8. Price slides up or down into place when the size changes. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 3. Hold + or - to keep counting ---------- */
  var hold = null, swallow = false;
  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest('product-page product-quantity .qty-plus, product-page product-quantity .qty-minus');
    if (!btn) return;
    var n = 0;
    hold = { btn: btn, repeated: false, t: setTimeout(function tick() {
      if (!hold || btn.classList.contains('disabled')) return;
      hold.repeated = true; btn.click(); n++;
      hold.t = setTimeout(tick, n > 8 ? 60 : 110);                     // speeds up the longer you hold
    }, 420) };
  }, { passive: true });
  function stopHold() { if (!hold) return; clearTimeout(hold.t); if (hold.repeated) swallow = true; hold = null; }
  document.addEventListener('pointerup', stopHold, { passive: true });
  document.addEventListener('pointercancel', stopHold, { passive: true });
  document.addEventListener('click', function (e) {                     // after a hold, drop the release click
    if (swallow && e.isTrusted && e.target.closest('.qty-plus, .qty-minus')) { e.preventDefault(); e.stopImmediatePropagation(); }
    swallow = false;
  }, true);

  /* ---------- 7. Tap the current tab to go back to the top ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('nav.pd-r2t a[href]'); if (!a) return;
    if (a.pathname !== location.pathname || a.search || a.hash || scrollY < 40) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
  });

  /* ---------- 8. Price slides into place ---------- */
  var lastPrice = null;
  function priceNode() { return document.querySelector('product-page .product-price--original, .product-actions__price .product-price--original'); }
  function val(el) { var m = (el.textContent || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : null; }
  function watchPrice() {
    var el = priceNode(); if (!el) return;
    var v = val(el);
    if (lastPrice !== null && v !== null && v !== lastPrice && !el.dataset.pdR16) {
      el.dataset.pdR16 = '1';
      el.classList.remove('pd-r16-price-up', 'pd-r16-price-down'); void el.offsetWidth;
      el.classList.add(v > lastPrice ? 'pd-r16-price-up' : 'pd-r16-price-down');
    }
    if (v !== null) lastPrice = v;
  }
  new MutationObserver(watchPrice).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  watchPrice();

})();
